import React from 'react'

export function TitleBarRightContainer({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return (
    <div
      className={'col-start-3 row-start-1 flex justify-end gap-2.5 md:gap-5'}
    >
      {children}
    </div>
  )
}
